import { TableSchema } from '../metadata-schema';
import { instelling } from './instelling';
import { VsoCluster } from '../enums/VsoCluster';

export const vest_cluster_vso: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "vest_cluster_vso",
	"description": "Definitie voor sys tabel vest_cluster_vso uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.SysTable",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"vcv_fk_inst": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"vcv_nm_cluster": {
			"label": "Cluster",
			"category": "Prestatieanalyse",
			"example": "Cluster 1, Cluster2+EMB, ...",
			"description": "Het cluster dat in CumLaude is ingesteld voor deze vestiging, en die wordt gebruikt voor het ophalen van percentielgrenzen.",
			"filter": false,
			"grouping": false,
			"exportable": true,
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": VsoCluster
		},
		"vcv_nm_schooljaar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
